export const ANCHOR_COMPARE_PACKAGES_SECTION = 'compare-packages-section';
